//src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import theme from "@/styles/theme.js";
import "@fortawesome/fontawesome-free/css/all.css";
Vue.use(Vuetify);

const opts = {
  theme,
  icons: {
    iconfont: "fa",
  },
};

export default new Vuetify(opts);



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js